export default __webpack_public_path__ + "static/media/news42.8489a74b.jpg";